import { Delete } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

export const DeleteIconButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton {...props}><Delete /></IconButton>
  );
};